export type TClientAppType = 'crm' | 'voice_analytics';

interface TClientAppTypeLabelProps {
  type: 'primary' | 'default';
  color: '' | 'light-blue';
  i18nKey: 'crm' | 'voiceAnalytics';
}

export const getClientAppTypeLabelProps = (appType: TClientAppType): TClientAppTypeLabelProps => {
  if (appType === 'voice_analytics') {
    return { type: 'primary', color: '', i18nKey: 'voiceAnalytics' };
  }
  return { type: 'default', color: 'light-blue', i18nKey: 'crm' };
};
